import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-[#C8102E] text-white text-center" data-id="element-285">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-287">
          <Shield size={64} className="mb-6 text-red-200" data-id="element-288" />
          <h2 className="text-4xl md:text-5xl font-bold mb-8 tracking-wide" data-id="element-289">
            OUR GUARANTEE
          </h2>
          <p className="text-2xl md:text-3xl font-medium leading-relaxed mb-8" data-id="element-290">
            We show up. We work hard. We leave your space completely clear.
          </p>
          <div className="bg-white/10 p-6 rounded-lg backdrop-blur-sm border border-white/20 inline-block" data-id="element-291">
            <p className="text-xl font-bold uppercase tracking-wider" data-id="element-292">
              If you're not happy with the job — we make it right. Period.
            </p>
            <p className="text-lg text-red-200 mt-2" data-id="element-293">
              No runaround. No excuses. Just results.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}